import { z } from 'zod';

export const userProfileSchema = z.object({
  first_name: z.string().nonempty('First name is required'),
  last_name: z.string().nonempty('Last name is required'),
  email: z.string().email('Invalid email address'),
  username: z.string().nonempty('Username is required'),
  timezone: z.string().optional()
});

export type UserProfileFormValues = z.infer<typeof userProfileSchema>;
